// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hvdtzorbnnysjvmdcklw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2ZHR6b3Jibm55c2p2bWRja2x3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcxMjkyMzUsImV4cCI6MjA3MjcwNTIzNX0.RQh1Bkhtn8TxotCfGGS6EiBcUSOmBSoKawARQwyP41s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
const isBrowser = typeof window !== "undefined";
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  
  auth: {
    storage: isBrowser ? localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {  params: {}  }
});
if (isBrowser) {
  supabase.realtime.removeAllChannels();
}